const moment = require("moment");
const React = require("react");
const T = require("prop-types");
const Style = require("./styles.scss");
const NavLink = require("react-router-dom").NavLink;
const RaisedButton = require("material-ui/RaisedButton").default;

module.exports = class PromoCodes extends React.Component {
    static propTypes = {
        isFetching: T.bool.isRequired,
        items: T.array,
        hasFetchedAll: T.bool.isRequired,

        fetchPromoCodes: T.func.isRequired
    };

    componentDidMount() {
        if (!this.props.hasFetchedAll) {
            this.props.fetchPromoCodes();
        }
    }

    renderPromoDate(promo) {
        const start = promo.startDate ? promo.startDate.format("L") : "---";
        const end = promo.endDate ? promo.endDate.format("L") : "---";

        return (
            <React.Fragment>
                {start}
                <br />
                {end}
            </React.Fragment>
        );
    }

    renderPromoStatus(promo) {
        const cutoff = moment.duration({ days: 10 });
        const now = moment.utc();

        let cls, text;

        if (promo.endDate && promo.endDate < now) {
            cls = "status-expired";
            text = "EXPIRED";
        } else if (promo.endDate && promo.endDate < now.add(cutoff)) {
            cls = "status-expiring-soon";
            text = (
                <React.Fragment>
                    EXPIRING
                    <br />
                    SOON
                </React.Fragment>
            );
        } else if (promo.startDate && promo.startDate > now) {
            cls = "status-upcoming";
            text = "UPCOMING";
        } else {
            cls = "status-active";
            text = "ACTIVE";
        }

        return <span className={Style[cls]}>{text}</span>;
    }

    renderPromoCodeTable() {
        if (this.props.items == null) {
            return "Not loaded yet";
        }

        const items = this.props.items.map(p => (
            <tr key={p.id}>
                <td className={Style.promoStatus}>
                    {this.renderPromoStatus(p)}
                </td>
                <td>
                    <span className={Style.promoCode}>{p.code}</span> (
                    {p.discount * 100}%)
                </td>
                <td className={Style.promoFromTo}>
                    From:
                    <br />
                    To:
                </td>
                <td className={Style.promoDate}>{this.renderPromoDate(p)}</td>
                <td>
                    <NavLink to={"/admin/promocodes/edit/" + p.id}>
                        EDIT
                    </NavLink>
                </td>
            </tr>
        ));

        return (
            <div className={Style.promoTable}>
                <table>
                    <tbody>{items}</tbody>
                </table>
            </div>
        );
    }

    render() {
        const { isFetching, items } = this.props;

        return (
            <div>
                <h2>Manage Promo Codes</h2>
                {isFetching ? (
                    "Loading..."
                ) : (
                    <div>
                        <div>{this.renderPromoCodeTable()}</div>
                        <NavLink to="/admin/promocodes/add">
                            <RaisedButton
                                primary
                                label="+ Add Promo"
                                labelStyle={{
                                    textTransform: "inherit"
                                }}
                            />
                        </NavLink>
                    </div>
                )}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes/components/PromoCodes.js